import { RoleDetails } from '@user-management/role-details';

export default function RoleDetailsPage() {
  return <RoleDetails />;
}
